<template>
  <div>
    <manageAssistantTeacherBarVue />
    <v-container fluid class="grey lighten-4 pa-6">
      <base-material-card
        icon="mdi-account-arrow-right"
        title="ระบบรายงานตัวครูผู้ช่วย ณ สถานศึกษา (กรณีโอนย้าย/พัฒนาท้องถิ่น)"
        class="px-5 py-3"
      >
        <v-row class="mb-4">
          <v-col cols="12" md="2">
            <v-card
              color="info"
              dark
              class="text-center pa-4 elevation-3"
              @click="manage_assistant_teacherQueryAll()"
            >
              <div class="text-h4 font-weight-bold">{{ count_alls }}</div>
              <div class="text-subtitle-2">จำนวนทั้งหมด</div>
              <v-icon large class="mt-2">mdi-account-group</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="success"
              dark
              class="text-center pa-4 elevation-3"
              @click="filterStatus('receipt')"
            >
              <div class="text-h4 font-weight-bold">{{ count_receipts }}</div>
              <div class="text-subtitle-2">รายงานตัวแล้ว</div>
              <v-icon large class="mt-2">mdi-check-circle</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="warning"
              dark
              class="text-center pa-4 elevation-3"
              @click="filterType('transfer_position')"
            >
              <div class="text-h4 font-weight-bold">
                {{ count_transfer_position }}
              </div>
              <div class="text-subtitle-2">กลุ่มโอนย้าย</div>
              <v-icon large class="mt-2">mdi-truck-delivery</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="error"
              dark
              class="text-center pa-4 elevation-3"
              @click="filterStatus('missing')"
            >
              <div class="text-h4 font-weight-bold">{{ count_missings }}</div>
              <div class="text-subtitle-2">ไม่มารายงานตัว</div>
              <v-icon large class="mt-2">mdi-account-remove</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="orange darken-2"
              dark
              class="text-center pa-4 elevation-3"
              @click="filterStatus('send')"
            >
              <div class="text-h4 font-weight-bold">{{ count_sends }}</div>
              <div class="text-subtitle-2">รอรายงานตัว</div>
              <v-icon large class="mt-2">mdi-clock-outline</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="purple"
              dark
              class="text-center pa-4 elevation-3"
              @click="manage_assistant_teacherCancelQueryAll()"
            >
              <div class="text-h4 font-weight-bold">
                {{
                  manage_assistant_teachers.filter(t => t.mt_collegeCC === "CC")
                    .length
                }}
              </div>
              <div class="text-subtitle-2">คำร้องขอยกเลิก</div>
              <v-icon large class="mt-2">mdi-file-cancel</v-icon>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-4 pa-4 rounded-lg" outlined>
          <v-row align="center">
            <v-col cols="12" md="5">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา (ชื่อ, สกุล, เลขบัตร, สาขา)"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" md="7" class="d-flex justify-end flex-wrap">
              <v-btn color="success" class="mr-2 mb-2" @click="exportToExcel">
                <v-icon left>mdi-file-excel</v-icon> Export Excel
              </v-btn>
              <v-btn
                color="info"
                class="mr-2 mb-2"
                @click="manage_assistant_teacherQueryAll"
              >
                <v-icon left>mdi-refresh</v-icon> รีเฟรชข้อมูล
              </v-btn>
              <v-btn color="warning" class="mb-2" @click="ApproveCollegeReport">
                <v-icon left>mdi-checkbox-multiple-marked</v-icon>
                อนุมัติการรายงานตัว (Batch)
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="manage_assistant_teachers"
          :search="search"
          class="elevation-2"
          :items-per-page="50"
        >
          <template v-slot:item.mt_date_app_now="{ item }">
            <div class="text-subtitle-2">
              <v-icon small color="primary" class="mr-1">mdi-calendar</v-icon>
              {{
                item.mt_date_app_now
                  | moment("add", "543 year")
                  | moment("D MMM YY")
              }}
            </div>
          </template>

          <template v-slot:item.mt_examgroup="{ item }">
            <v-chip x-small dark :color="getTypeColor(item.mt_type_personnel)">
              {{ getTypeName(item.mt_type_personnel) }}
            </v-chip>
          </template>

          <template v-slot:item.mt_sequence="{ item }">
            <v-avatar
              color="blue-grey"
              size="24"
              class="white--text text-caption"
            >
              {{ item.mt_sequence }}
            </v-avatar>
          </template>

      
          <template v-slot:item.mt_admissions_status="{ item }">
            <div v-if="item.mt_id === editedItem.mt_id">
              <v-select
                v-model="editedItem.mt_admissions_status"
                :items="mt_admissions_statusSe"
                dense
                outlined
                hide-details
              ></v-select>
            </div>
            <v-chip
              v-else
              :color="getStatusColor(item.mt_admissions_status)"
              dark
              small
              label
              @click="manage_assistant_teacherEdit(item.mt_id)"
            >
              <v-icon left small>{{
                getStatusIcon(item.mt_admissions_status)
              }}</v-icon>
              {{ getStatusText(item.mt_admissions_status) }}
            </v-chip>
          </template>

          <template v-slot:item.mt_collegeCC="{ item }">
            <v-chip
              v-if="item.mt_collegeCC === 'CC'"
              color="error"
              dark
              small
              @click="CancelAdmissions(item.mt_id)"
            >
              <v-icon left small>mdi-alert-circle</v-icon> ขอยกเลิก
            </v-chip>
            <v-chip
              v-else-if="item.mt_collegeCC === 'CF'"
              color="success"
              outlined
              small
            >
              <v-icon left small>mdi-check</v-icon> อนุมัติแล้ว
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div v-if="item.mt_id === editedItem.mt_id" class="d-flex">
              <v-btn icon color="success" @click="save()"
                ><v-icon>mdi-content-save</v-icon></v-btn
              >
              <v-btn icon color="error" @click="close"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </div>
            <div v-else class="d-flex">
              <v-btn
                v-if="
                  item.mt_admissions_status === 'receipt' &&
                    item.mt_collegeCC !== 'CF'
                "
                color="primary"
                small
                depressed
                class="mr-2"
                @click="ConfirmAssistantTeach(item.mt_id)"
              >
                อนุมัติบรรจุ
              </v-btn>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="grey">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click="manage_assistant_teacherEdit(item.mt_id)"
                  >
                    <v-list-item-title
                      ><v-icon left small color="warning">mdi-pencil</v-icon
                      >แก้ไขสถานะ</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    @click="viewadmissionsFile(item.mt_admissions_file)"
                    v-if="item.mt_admissions_file"
                  >
                    <v-list-item-title
                      ><v-icon left small color="info">mdi-printer</v-icon
                      >ดูหนังสือนำส่ง</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="deleteItem(item.mt_id)">
                    <v-list-item-title class="red--text"
                      ><v-icon left small color="red">mdi-delete</v-icon
                      >ลบ/ยกเลิกรายการ</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog
        v-model="editmanage_assistant_teacherdialog"
        persistent
        max-width="80%"
      >
      <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="แก้ไขข้อมูลครูผู้ช่วย รายงานตัว"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <div class="text-center font-weight-bold error--text" v-if="editmanage_assistant_teacher.mt_licence_cc==='CC'">
               ขอยกเลิกรายการเนื่องจาก : {{ editmanage_assistant_teacher.mt_licence_cc_detail }}
              </div>
              <v-form ref="editmanage_assistant_teacherform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="เลขบัตรประชาชน"
                        v-model="editmanage_assistant_teacher.mt_id_card"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md4>
                      <v-autocomplete
                        :items="branchs"
                        item-text="name_branch"
                        item-value="id_branch"
                        outlined
                        label="สาขาวิชา"
                        v-model="editmanage_assistant_teacher.mt_id_branch"
                        required
                        :rules="[v => !!v || '']"
                      >
                        <template v-slot:item="{ item }">
                          <div class="pa-2">
                            <div class="divTab50">
                              {{ item.id_branch }} :
                              {{ item.name_branch }}
                            </div>
                          </div>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="ลำดับที่สอบได้"
                        v-model="editmanage_assistant_teacher.mt_sequence"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="คำนำหน้าชื่อ"
                        v-model="editmanage_assistant_teacher.mt_title_s"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="ชื่อ"
                        v-model="editmanage_assistant_teacher.mt_frist_name"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="นามสกุล"
                        v-model="editmanage_assistant_teacher.mt_last_name"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md6>
                      <v-autocomplete
                        :items="colleges"
                        item-text="college_name"
                        item-value="college_code"
                        outlined
                        label="วิทยาลัย"
                        v-model="editmanage_assistant_teacher.mt_college_code"
                        required
                        :rules="[v => !!v || '']"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md6>
                      <v-text-field
                        outlined
                        label="เลขที่ตำแหน่ง"
                        v-model="editmanage_assistant_teacher.mt_id_position"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="วันเกิด"
                        v-model="editmanage_assistant_teacher.mt_brith_day"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="เดือนเกิด"
                        v-model="editmanage_assistant_teacher.mt_brith_month"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="ปีเกิด"
                        v-model="editmanage_assistant_teacher.mt_brith_year"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="เบอร์โทร"
                        v-model="editmanage_assistant_teacher.mt_tel_p"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="ชื่อย่อวุฒิการศึกษา"
                        v-model="editmanage_assistant_teacher.mt_ed_abb"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="สาขาวิชาเอก"
                        v-model="editmanage_assistant_teacher.mt_ed_name"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="วันที่บรรจุ"
                        v-model="editmanage_assistant_teacher.mt_appoin_day"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="เดือนที่บรรจุ"
                        v-model="editmanage_assistant_teacher.mt_appoin_month"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="ปีที่บรรจุ"
                        v-model="editmanage_assistant_teacher.mt_appoin_year"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        outlined
                        label="คำสั่งที่"
                        v-model="editmanage_assistant_teacher.mt_order_app"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-autocomplete
                        :items="mt_status_select"
                        item-text="text"
                        item-value="value"
                        outlined
                        label="สถานะ"
                        v-model="editmanage_assistant_teacher.mt_status"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex md4>
                      <v-autocomplete
                        :items="mt_examtype_select"
                        item-text="text"
                        item-value="value"
                        outlined
                        label="วิธีการ"
                        v-model="editmanage_assistant_teacher.mt_examtype"
                        required
                        :rules="[v => !!v || '']"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md4>
                      <v-autocomplete
                        :items="mt_examgroup_select"
                        item-text="text"
                        item-value="value"
                        outlined
                        label="เขตพื้นที่"
                        v-model="editmanage_assistant_teacher.mt_examgroup"
                        required
                        :rules="[v => !!v || '']"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md4>
                      <v-autocomplete
                        :items="type_personnelApp"
                        item-text="text"
                        item-value="value"
                        outlined
                        label="ประเภทการบรรจุ"
                        v-model="editmanage_assistant_teacher.mt_type_personnel"
                        required
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md4>
                      <v-text-field
                        v-model="editmanage_assistant_teacher.mt_date_app_now"
                        label="วันที่บรรจุ"
                        prepend-icon="mdi-calendar"
                        outlined
                        type="date"
                      ></v-text-field>
                    </v-flex>

                    <v-flex md4>
                      <v-text-field
                        v-model="
                          editmanage_assistant_teacher.mt_date_app_postitionnow
                        "
                        label="วันที่ดำรงตำแหน่ง"
                        prepend-icon="mdi-calendar"
                        outlined
                        type="date"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-radio-group
                        v-model="
                          editmanage_assistant_teacher.mt_admissions_status
                        "
                        row
                      >
                        <template v-slot:label>
                          <div>
                            สถานะการรายงานตัว ณ สถานศึกษา
                            <strong> ปรับปรุง</strong>
                          </div>
                        </template>
                        <v-radio value="send">
                          <template v-slot:label>
                            <div>
                              <strong class="warning--text"
                                >ส่งข้อมูลไปยังสถานศึกษา</strong
                              >
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="receipt">
                          <template v-slot:label>
                            <div>
                              <strong class="success--text"
                                >รับรายงานตัว</strong
                              >
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="missing">
                          <template v-slot:label>
                            <div>
                              <strong class="error--text"
                                >สละสิทธิ์ไม่รายงานตัว</strong
                              >
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex md12>
                      <v-radio-group
                        v-model="editmanage_assistant_teacher.mt_status_report"
                        row
                      >
                        <template v-slot:label>
                          <div>
                            <strong>สถานะการการตรวจสอบเอกสาร</strong>
                          </div>
                        </template>
                        <v-radio value="">
                          <template v-slot:label>
                            <div>
                              <strong class="warning--text">ดำเนินการ</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="confirm">
                          <template v-slot:label>
                            <div>
                              <strong class="success--text"
                                >รอส่วนกลางตรวจสอบ</strong
                              >
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="approve">
                          <template v-slot:label>
                            <div>
                              <strong class="error--text">ตรวจสอบผ่าน</strong>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-flex>

                     <v-radio-group
                  v-model="editmanage_assistant_teacher.mt_transfer_status"
                  row
                  dense
                >
                  <template v-slot:label>
                    <strong>สถานะรับรายงานตัว:</strong>
                  </template>
                  <v-radio :value="1" label="เปิด" color="success"></v-radio>
                  <v-radio :value="0" label="ปิด" color="error"></v-radio>
                </v-radio-group>
                  </v-layout>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                outlined
                @click.stop="editmanage_assistant_teacherdialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="editmanage_assistant_teacherSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog
        v-model="Confirmmanage_assistant_teacherdialog"
        persistent
        max-width="800px"
      >
        <v-card class="rounded-xl">
          <v-toolbar color="primary" dark flat>
            <v-icon class="mr-2">mdi-account-check</v-icon>
            <v-toolbar-title>ยืนยันการอนุมัติบรรจุครูผู้ช่วย</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="Confirmmanage_assistant_teacherdialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-h6">{{
                      editmanage_assistant_teacher.mt_name
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >ผู้ได้รับการบรรจุ</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="menu4"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editmanage_assistant_teacher.mt_dateAppoint"
                      label="วันที่บรรจุ/เริ่มปฏิบัติงาน"
                      prepend-icon="mdi-calendar"
                      readonly
                      outlined
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editmanage_assistant_teacher.mt_dateAppoint"
                    @input="menu4 = false"
                    locale="th"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-divider class="my-3"></v-divider>
            <div class="text-subtitle-1 font-weight-bold mb-2">
              คณะกรรมการประเมิน
            </div>
            <v-simple-table dense>
              <thead>
                <tr class="grey lighten-4">
                  <th>ตำแหน่งกรรมการ</th>
                  <th>ชื่อ-นามสกุล</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(comm, index) in assistantcommittees" :key="index">
                  <td>
                    {{
                      comm.assistantcommitteePositon === "1"
                        ? "ผู้ทรงคุณวุฒิภายนอก"
                        : "กรรมการภายใน"
                    }}
                  </td>
                  <td>{{ comm.committeeName }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>

          <v-card-actions class="pb-6 px-6">
            <v-spacer></v-spacer>
            <v-btn
              text
              large
              rounded
              @click="Confirmmanage_assistant_teacherdialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="primary"
              large
              rounded
              @click="Confirmmanage_assistant_teacherSubmit()"
            >
              <v-icon left>mdi-content-save-check</v-icon> ยืนยันบรรจุ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="pdfmt_admissions_filedialog" max-width="900px">
        <v-card>
          <v-toolbar dense flat color="grey darken-3" dark>
            <v-toolbar-title>ตัวอย่างเอกสาร</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="pdfmt_admissions_filedialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <div style="height: 80vh;">
            <embed
              :src="'/HRvecfiles/' + pdf_files"
              width="100%"
              height="100%"
            />
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import manageAssistantTeacherBarVue from "../../../components/admin/manageAssistantTeacherBar.vue";
import * as XLSX from "xlsx"; // For Excel Export
import { logSensitiveAccess } from "@/utils/sensitiveAccessLog";

export default {
  name: "HRvecManageAssistantTeacherTran",
  components: { manageAssistantTeacherBarVue },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      search: "",

      // Data
      manage_assistant_teachers: [],
      periodassteachs: {},
      branchs: [],
      assistantcommittees: [],

      // Dialogs
      editmanage_assistant_teacherdialog: false,
      Confirmmanage_assistant_teacherdialog: false,
      pdfmt_admissions_filedialog: false,

      // Forms & Editing
      editmanage_assistant_teacher: {},
      editedItem: { mt_id: 0 },
      menu4: false,
      menu5: false,
      menu6: false,
      date: new Date().toISOString().substr(0, 10),

      // Dashboard Counts
      count_alls: 0,
      count_receipts: 0,
      count_transfer_position: 0,
      count_missings: 0,
      count_sends: 0,

      // Helper
      pdf_files: "",
      insertselects: {},
      deletedItemmat: {},
      personnel_temporarys: {},
      manage_assistant_teacherCF: {},

      // Static Data
      headers: [
        { text: "ลำดับ", value: "mt_sequence", align: "center", width: "70px" },
        { text: "รหัสบัตรประชาชน", value: "mt_id_card", width: "150px" },
        { text: "ชื่อ-นามสกุล", value: "mt_name" },
        { text: "ประเภท", value: "mt_examgroup", align: "center" },
        { text: "วันที่บรรจุ", value: "mt_date_app_now", align: "center" },
        { text: "สาขาวิชา", value: "name_branch" },
        { text: "วิทยาลัย", value: "college_name" },
        { text: "สถานะ", value: "mt_admissions_status", align: "center" },
        { text: "คำร้อง", value: "mt_collegeCC", align: "center" },
        { text: "ดำเนินการ", value: "actions", sortable: false, align: "right" }
      ],
      mt_admissions_statusSe: [
        { text: "รายงานตัวปกติ (Receipt)", value: "receipt" },
        { text: "ไม่มารายงานตัว (Missing)", value: "missing" }
      ],
      mt_admissions_status_select: [
        { text: "มารายงานตัว", value: "receipt" },
        { text: "ไม่มารายงานตัว", value: "missing" }
      ],
      type_personnelApp: [
        { text: "ครูพัฒนาท้องถิ่น", value: "local_dev" },
        { text: "ครูโอนย้าย", value: "transfer_position" }
      ],   mt_status_select: [
        { text: "ปกติ", value: "normal" },
        { text: "สละสิทธิ์", value: "disclaim" }
      ],
      mt_examtype_select: [
        { text: "คัดเลือก(ภายใน)", value: "select" },
        { text: "ทั่วไป(ภายนอก)", value: "recruit" }
      ],
      mt_examgroup_select: [
        { text: "ทั่วไป", value: "general" },
        { text: "ชายแดนภาคใต้", value: "southern" }
      ],
      colleges: []
    };
  },

  async mounted() {
    await this.initialize();
    logSensitiveAccess(
      this.$http,
      "manage_assistant_college_report_tran",
      "view",
      `รอบ ${this.periodassteachs.periodAssTeachTimes}/${this.periodassteachs.periodAssTeachYear}`
    );
  },

  methods: {
      async collegeQuery() {
      let result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data;
    },

    async initialize() {
      this.loading = true;
      await this.periodassteachQuery();
      await this.branchQuery();
      await this.collegeQuery();
      await this.manage_assistant_teacherQueryAll();
      this.loading = false;
    },

    // --- Data Fetching ---
    async periodassteachQuery() {
      let result = await this.$http.post("periodassteach.php", {
        ApiKey: this.ApiKey,
        periodAssTeachEnablePro: "1"
      });
      this.periodassteachs = result.data;
    },

    async branchQuery() {
      let result = await this.$http.post("branch.php", { ApiKey: this.ApiKey });
      this.branchs = result.data;
    },

    async manage_assistant_teacherQueryAll() {
      this.loading = true;
      // Fetch specifically for transfer_position
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_type_personnel: "transfer_position"
      });
      this.manage_assistant_teachers = result.data;
      this.calculateDashboard();
      this.loading = false;
    },

    // --- Dashboard & Filtering ---
    calculateDashboard() {
      const data = this.manage_assistant_teachers;
      this.count_alls = data.length;
      this.count_receipts = data.filter(
        i => i.mt_admissions_status === "receipt"
      ).length;
      this.count_missings = data.filter(
        i => i.mt_admissions_status === "missing"
      ).length;
      this.count_sends = data.filter(
        i => i.mt_admissions_status === "send"
      ).length;
      this.count_transfer_position = data.filter(
        i => i.mt_type_personnel === "transfer_position"
      ).length;
    },

    filterStatus(status) {
      this.search = status; // Quick filter using search prop
    },
    filterType(type) {
      // Since we only load transfer_position, this might be redundant but good for consistency
      this.search = type === "transfer_position" ? "ครูโอนย้าย" : type;
    },

    // --- Helper Functions for UI ---
    getTypeColor(type) {
      if (type === "transfer_position") return "orange darken-2";
      if (type === "local_dev") return "teal";
      return "grey";
    },
    getTypeName(type) {
      if (type === "transfer_position") return "ครูโอนย้าย";
      if (type === "local_dev") return "พัฒนาท้องถิ่น";
      return "ทั่วไป";
    },
    getStatusColor(status) {
      if (status === "receipt") return "success";
      if (status === "missing") return "error";
      return "warning";
    },
    getStatusText(status) {
      if (status === "receipt") return "รายงานตัวแล้ว";
      if (status === "missing") return "ไม่มารายงานตัว";
      return "รอรายงานตัว";
    },
    getStatusIcon(status) {
      if (status === "receipt") return "mdi-check-circle";
      if (status === "missing") return "mdi-close-circle";
      return "mdi-clock";
    },

    // --- Export Excel ---
    exportToExcel() {
      if (this.manage_assistant_teachers.length === 0) return;

      const data = this.manage_assistant_teachers.map(item => ({
        ลำดับ: item.mt_sequence,
        บัตรประชาชน: item.mt_id_card,
        "ชื่อ-นามสกุล": item.mt_name,
        ประเภท: this.getTypeName(item.mt_type_personnel),
        วันที่บรรจุ: item.mt_date_app_now,
        สาขา: item.name_branch,
        สถานศึกษา: item.college_name,
        สถานะ: this.getStatusText(item.mt_admissions_status),
        หมายเหตุ: item.mt_collegeCC === "CC" ? "ขอยกเลิก" : ""
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "รายชื่อครูโอนย้าย");
      const filename = `รายงานครูโอนย้าย_${this.periodassteachs.periodAssTeachTimes}_${this.periodassteachs.periodAssTeachYear}.xlsx`;
      XLSX.writeFile(wb, filename);
      logSensitiveAccess(
        this.$http,
        "manage_assistant_college_report_tran",
        "export",
        filename
      );
    },

    // --- Actions & Dialogs ---

    // Quick Edit Status in Table
    manage_assistant_teacherEdit(mt_id) {
      this.$http
        .post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          mt_id: mt_id
        })
        .then(res => {
          this.editmanage_assistant_teacher = res.data;
          this.editmanage_assistant_teacherdialog = true;
        });
    },

    // View PDF
    viewadmissionsFile(file) {
      this.pdf_files = file;
      this.pdfmt_admissions_filedialog = true;
    },

    // Handle Cancel Request (Approve Cancel)
    CancelAdmissions(mt_id) {
      this.manage_assistant_teacherEdit(mt_id);
    },

    // Save Quick Edit
    save() {
      this.editedItem.ApiKey = this.ApiKey;
      this.$http
        .post("manage_assistant_teacher.update.php", this.editedItem)
        .then(res => {
          if (res.data.status) {
            Swal.fire({
              icon: "success",
              title: "บันทึกเรียบร้อย",
              timer: 1500,
              showConfirmButton: false
            });
            this.manage_assistant_teacherQueryAll();
            this.close();
          }
        });
    },
    close() {
      this.editedItem = { mt_id: 0 };
    },

    // Update Status from Dialog
    async editmanage_assistant_teacherUpdateSubmit() {
      if (this.$refs.editmanage_assistant_teacherform.validate()) {
        this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
        this.editmanage_assistant_teacher.mt_admissions_status = this.editmanage_assistant_teacher.mt_admissions_statusSelect;

        let result = await this.$http.post(
          "manage_assistant_teacher.update.php",
          this.editmanage_assistant_teacher
        );
        if (result.data.status) {
          Swal.fire({
            icon: "success",
            title: "แก้ไขข้อมูลสำเร็จ",
            timer: 1500,
            showConfirmButton: false
          });
          this.manage_assistant_teacherQueryAll();
          this.editmanage_assistant_teacherdialog = false;
        }
      }
    },

  async editmanage_assistant_teacherSubmit() {
      Swal.fire({
        title: "ยืนยันการบันทึก",
        text: "ข้อมูลจะถูกบันทึก",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน"
      }).then(async res => {
        if (res.isConfirmed) {
          this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
          let result = await this.$http.post(
            "manage_assistant_teacher.update.php",
            this.editmanage_assistant_teacher
          );
          if (result.data.status) {
            Swal.fire({
              icon: "success",
              title: "อนุมัติการยกเลิกเรียบร้อย",
              timer: 1500,
              showConfirmButton: false
            });
            this.manage_assistant_teacherQueryAll();
            this.editmanage_assistant_teacherdialog = false;
          }
        }
      });
    },


    // Approve Cancel Request (Reset to Send)
    /*async editmanage_assistant_teacherSubmit() {
      Swal.fire({
        title: "ยืนยันการยกเลิก?",
        text: "ข้อมูลจะถูกรีเซ็ตกลับไปสถานะ 'รอรายงานตัว' และลบไฟล์แนบ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน"
      }).then(async res => {
        if (res.isConfirmed) {
          this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
          this.editmanage_assistant_teacher.mt_admissions_status = "send";
          this.editmanage_assistant_teacher.mt_collegeCC = ""; 
          this.editmanage_assistant_teacher.mt_admissions_file = ""; 
          if (this.editmanage_assistant_teacher.mt_admissions_file) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename:
                "../HRvecfiles/" +
                this.editmanage_assistant_teacher.mt_admissions_file
            });
          }

          let result = await this.$http.post(
            "manage_assistant_teacher.update.php",
            this.editmanage_assistant_teacher
          );
          if (result.data.status) {
            Swal.fire({
              icon: "success",
              title: "อนุมัติการยกเลิกเรียบร้อย",
              timer: 1500,
              showConfirmButton: false
            });
            this.manage_assistant_teacherQueryAll();
            this.editmanage_assistant_teacherdialog = false;
          }
        }
      });
    },*/

    // Confirm Hiring (Transfer)
    async ConfirmAssistantTeach(mt_id) {
      let res = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = res.data;

      let resComm = await this.$http.post("assistantcommittee.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeTime: this.editmanage_assistant_teacher.mt_times,
        assistantcommitteeYear: this.editmanage_assistant_teacher.mt_years,
        assistantcommitteeIDCardTeach: this.editmanage_assistant_teacher
          .mt_id_card
      });
      this.assistantcommittees = resComm.data;
      this.Confirmmanage_assistant_teacherdialog = true;
    },

    async Confirmmanage_assistant_teacherSubmit() {
      // Prepare Data for Update & Insert
      this.manage_assistant_teacherCF = {
        ApiKey: this.ApiKey,
        mt_id: this.editmanage_assistant_teacher.mt_id,
        mt_collegeCC: "CF", // Confirmed
        mt_dateAppoint: this.editmanage_assistant_teacher.mt_dateAppoint
      };

      this.personnel_temporarys = {
        ApiKey: this.ApiKey,
        college_code: this.editmanage_assistant_teacher.mt_college_code,
        id_card: this.editmanage_assistant_teacher.mt_id_card,
        title_s: this.editmanage_assistant_teacher.mt_title_s,
        frist_name: this.editmanage_assistant_teacher.mt_frist_name,
        last_name: this.editmanage_assistant_teacher.mt_last_name,
        position_name: "ครูผู้ช่วย",
        id_position: this.editmanage_assistant_teacher.mt_id_position,
        type_positition: "ครูผู้ช่วย",
        rang_level: "ครูผู้ช่วย",
        date_rang_level: this.editmanage_assistant_teacher.mt_dateAppoint,
        // ... Map other fields as per original logic ...
        ed_abb: this.editmanage_assistant_teacher.mt_ed_abb,
        ed_name: this.editmanage_assistant_teacher.mt_ed_name,
        brith_day: this.editmanage_assistant_teacher.mt_brith_day,
        brith_month: this.editmanage_assistant_teacher.mt_brith_month,
        brith_year: this.editmanage_assistant_teacher.mt_brith_year,
        appoin_day: this.editmanage_assistant_teacher.mt_appoin_day,
        appoin_month: this.editmanage_assistant_teacher.mt_appoin_month,
        appoin_year: this.editmanage_assistant_teacher.mt_appoin_year,
        order_app_now: this.editmanage_assistant_teacher.mt_order_app,
        date_app_now: this.editmanage_assistant_teacher.mt_dateAppoint,
        date_app_positonnow: this.editmanage_assistant_teacher.mt_dateAppoint,
        tel_p: this.editmanage_assistant_teacher.mt_tel_p,
        user_status: "teacher"
      };

      let res1 = await this.$http.post(
        "manage_assistant_teacher.update.php",
        this.manage_assistant_teacherCF
      );
      let res2 = await this.$http.post(
        "manage_assistant_teacherAssistant.insert.php",
        this.personnel_temporarys
      );

      if (res1.data.status && res2.data.status) {
        Swal.fire({
          icon: "success",
          title: "ยืนยันการบรรจุเรียบร้อย",
          timer: 1500,
          showConfirmButton: false
        });
        this.manage_assistant_teacherQueryAll();
        this.Confirmmanage_assistant_teacherdialog = false;
      } else {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถบันทึกข้อมูลได้"
        });
      }
    },

    // Delete / Reset Item
    deleteItem(mt_id) {
      Swal.fire({
        title: "ต้องการลบ/รีเซ็ตรายการ?",
        text: "ข้อมูลการรายงานตัวจะถูกลบและต้องดำเนินการใหม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "ลบรายการ"
      }).then(async result => {
        if (result.isConfirmed) {
          // Reset Logic similar to original code
          this.deletedItemmat = {
            ApiKey: this.ApiKey,
            mt_id: mt_id,
            mt_admissions_status: "send",
            mt_collegeCC: "",
            mt_admissions_file: "" // Should handle file deletion backend side too
          };
          // Call Update
          await this.$http.post(
            "manage_assistant_teacher.update.php",
            this.deletedItemmat
          );
          this.manage_assistant_teacherQueryAll();
          Swal.fire("รีเซ็ตเรียบร้อย", "", "success");
        }
      });
    },

    // Batch Approve
    ApproveCollegeReport() {
      this.insertselects.ApiKey = this.ApiKey;
      Swal.fire({
        title: "อนุมัติการรายงานตัวทั้งหมด?",
        text: "ระบบจะบันทึกข้อมูลผู้ที่ 'รายงานตัวแล้ว' ลงในฐานข้อมูลบุคลากร",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "ยืนยันอนุมัติ"
      }).then(async result => {
        if (result.isConfirmed) {
          let res1 = await this.$http.post(
            "personnel_temporary.insertselect.tran.php",
            this.insertselects
          );
          let res2 = await this.$http.post(
            "personnel_etc.insertselect.tran.php",
            this.insertselects
          );

          if (res1.data.status || res2.data.status) {
            Swal.fire({
              icon: "success",
              title: "ประมวลผลเรียบร้อย",
              timer: 1500,
              showConfirmButton: false
            });
          }
        }
      });
    },

    // API for cancel requests list
    async manage_assistant_teacherCancelQueryAll() {
      this.loading = true;
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times: this.periodassteachs.periodAssTeachTimes,
        mt_years: this.periodassteachs.periodAssTeachYear,
        mt_collegeCC: "CC"
      });
      this.manage_assistant_teachers = result.data;
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.hide-idcard-number {
  display: inline-block;
  font-family: monospace;
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 4px;
  color: #555;
}
.hide-idcard-number::after {
  content: "XXXX";
  margin-left: -35px; /* Adjust based on font size to cover last digits or use JS masking instead */
  background-color: #f5f5f5;
  color: #999;
}
</style>
